import * as React from "react";
import { Select } from "antd";
import { useContext, useState, useEffect } from "react";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { FormComponentProps } from "antd/lib/form";
import { ServiceContext } from "src/services/provider/Service.provider";
import { IFillSelect } from "src/services/interfaces/generic/IFillSelect";

interface ISelectCourt {
  value: number;
  courtTypeId: number;
  onChange: (id: number) => void;
  isCourtRequired: boolean;
  onlyActive: boolean;
}

export function SelectCourt(props: ISelectCourt & FormComponentProps) {
  const { courtService } = useContext(ServiceContext);
  const [courts, setCourts] = useState<IFillSelect[]>([]);
  const [canClearFields, setCanClearFields] = useState<boolean>(false);

  const Option = Select.Option;

  useEffect(() => {
    if (props.courtTypeId) {
      if (canClearFields) {
        clearFields();
      }
      getCourtsByType();
      setCanClearFields(true);
    }
  }, [props.courtTypeId]);

  const clearFields = () => {
    props.onChange(null);
    setCourts([]);
    props.form.setFieldsValue({
      ddlCourt: ""
    });
  };

  function getCourtsByType() {
    courtService.getCourtsByType(props.courtTypeId, props.onlyActive).then(result => {
      if (result) {
        setCourts(result);
        props.form.setFieldsValue({
          ddlCourt: result.find(c => c.id === props.value)?.value
        });
      } else {
        setCourts([]);
      }
    });
  }

  return (
    <PbrSelect
      name="ddlCourt"
      size="large"
      formItemProps={{ label: `Tribunal` }}
      formWrapper={props.form}
      showSearch
      value={props.value}
      placeholder="Selecione o Tribunal"
      onChange={e => props.onChange(Number(e))}
      rules={[{ required: props.isCourtRequired, message: "Informe o Tribunal" }]}
    >
      {courts?.map((e, i) => (
        <Option key={i.toString()} value={e.id}>{`${e.value}`}</Option>
      ))}
    </PbrSelect>
  );
}




// WEBPACK FOOTER //
// ./src/components/common/SelectCourtTypeCourtCorrectionType/SelectCourt.tsx